import { DatePipe } from '@angular/common';
import { Injectable } from '@angular/core';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';


@Injectable({
  providedIn: 'root'
})
export class XlsxService {

    constructor() { }

    async delay(ms: number) {
        return new Promise( resolve => setTimeout(resolve, ms) );
    }

    async obtenerBSTR( data: Uint8Array, idx: number, length: number ) {
        let bstr = ""
        for (let i=idx; i < length; i++) {
            bstr += String.fromCharCode(data[i]); 
            if ( (i + 1 ) % 200 === 0 ) { await this.delay(100) }
        }
        return bstr;
    }

    async toListJson( fileReader: FileReader, sheetsQty = 1 ) {
        const arrayBuffer: any = fileReader.result;
        const data = new Uint8Array(arrayBuffer);
        const worksheets: any[] = [];

        let bstr = ""
        const maxLength = 2000;
        const cantidad = Math.floor(data.length / maxLength);
        const resto = data.length % maxLength;
        let tareas = [];
        for (let index = 0; index < cantidad; index++) {
            tareas.push( this.obtenerBSTR(data, index*maxLength, (index*maxLength + maxLength)) );
            if ( tareas.length === maxLength ) {
                await this.delay(200);
                const resp = await Promise.all(tareas);
                bstr = resp.join("");
                const workbook = XLSX.read(bstr, {type:"binary", raw: true});
                let cont = 0
                while( cont < sheetsQty ) {
                    const sheet_name = workbook.SheetNames[cont];
                    const worksheet = workbook.Sheets[sheet_name];
                    let sheet_json = XLSX.utils.sheet_to_json(worksheet, {raw:true});
                    // console.log(sheet_json);                    
                    worksheets.push( ...sheet_json );
                    cont += 1;
                }
                bstr = ""
                tareas = [];
                if ( index === 4000) { break };
            }
        }
        if ( resto > 0 ) {
            tareas.push( this.obtenerBSTR(data, cantidad*maxLength, (cantidad*maxLength + resto)) );
            const resp = await Promise.all(tareas);
            await this.delay(100);
            bstr = resp.join("");
            await this.delay(100);
            const workbook = XLSX.read(bstr, {type:"binary", raw: true});
            let cont = 0
            while( cont < sheetsQty ) {
                const sheet_name = workbook.SheetNames[cont];
                const worksheet = workbook.Sheets[sheet_name];
                let sheet_json =  XLSX.utils.sheet_to_json(worksheet, {raw:true});
                // console.log(sheet_json);
                worksheets.push( ...sheet_json );
                cont += 1;
            }            
        }
        // for(let i = 0; i != data.length; ++i) {
        //     bstr += String.fromCharCode(data[i]);
        //     if ( (i + 1) % 100 === 0 ) { await this.delay(200) }
        // }
        // console.log(worksheets);        
        return [worksheets];
    }

    async downloadDoc( nombre: string ) {
        let link = document.createElement('a');
        link.setAttribute('type', 'hidden');
        link.href = `assets/documents/${ nombre }.xlsx`;
        link.download = `${ nombre }.xlsx`;
        document.body.appendChild(link);
        link.click();
        link.remove();
    }

    async exportAsExcelFile(json: any[], excelFileName: string) {
        const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
        const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };  
        const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });  
        this.saveAsExcelFile(excelBuffer, excelFileName);  
    }  
    private async saveAsExcelFile(buffer: any, fileName: string) {
        const datePipe = new DatePipe('es-PY');
        const fecha = datePipe.transform(new Date(), 'dd_MM_yyyy_HH_mm_ss');
        const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
        const EXCEL_EXTENSION = '.xlsx';
        const data: Blob = new Blob([buffer], {type: EXCEL_TYPE});
        FileSaver.saveAs(data, fileName + '_' + fecha + EXCEL_EXTENSION);
    }
}
